import styled from 'styled-components';

const Title = styled.div`
    font-size: 1.5rem;
    font-weight: 900;
    text-transform: capitalize;
`;

export default Title;
